import { useState, useEffect } from "react";
import {
  createNewServiceGroup,
  getAllServicesGroup,
  deleteServiceGroup,
  updateServiceGroup,
} from "../../api/servicesGroupApi";
import { useAuth } from "../../context/AuthContext";
import EditIcon from "../../assets/icons/edit-icon.png";
import DeleteIcon from "../../assets/icons/delete-icon.png";

const useServiceGroup = () => {
  const { user } = useAuth();
  const [newServiceGroup, setNewServiceGroup] = useState({
    name: null,
    orderNumber: 1,
  });

  const [editServiceGroupName, setEditServiceGroupName] = useState(null);
  const [serviceGroupList, setServiceGroupList] = useState([]);
  const [displayServiceGroups, setDisplayServiceGroups] = useState([]);
  const [showNewModal, setShowNewModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showMessage, setShowMessage] = useState(false);
  const [message, setMessage] = useState(false);
  const [deleteItem, setDeleteItem] = useState({});
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const columns = [
    { header: "Display Order", accessor: "orderNumber" },
    { header: "Group Name", accessor: "name" },
    {
      header: "Actions",
      render: (row, { onEdit, onDelete }) => (
        <>
          <button className="btn btn-edit " onClick={() => onEdit(row)}>
            <img src={EditIcon} />
          </button>
          <button className="btn btn-delete" onClick={() => onDelete(row)}>
            <img src={DeleteIcon} />
          </button>
        </>
      ),
    },
  ];
  useEffect(() => {
    fetchServiceGroups();
  }, []);
  const fetchServiceGroups = async () => {
    const response = await getAllServicesGroup(user.barberShop);
    setServiceGroupList(response);
    var displayServiceGroupList = response.map((s) => ({
      id: s.id,
      name: s.name,
      orderNumber: s.displayOrderNumber,
    }));
    setDisplayServiceGroups(displayServiceGroupList);
    setNewServiceGroup({
      name: null,
      orderNumber: displayServiceGroupList.length + 1 || 1,
    });
  };
  const onAddClick = (serviceGroup) => {
    setNewServiceGroup({
      name: null,
      orderNumber: displayServiceGroups.length + 1 || 1,
    });
    setEditServiceGroupName(null);
    setShowEditModal(false);
    setShowNewModal(true);
  };
  const onEditClick = (serviceGroup) => {
    setShowEditModal(true);
    setShowNewModal(false);
    setNewServiceGroup(null);
    setEditServiceGroupName(serviceGroup);
  };
  const onClosModal = () => {
    setShowEditModal(false);
    setShowNewModal(false);
    setNewServiceGroup(null);
    setEditServiceGroupName(null);
  };
  const handleConfirmDelete = async () => {
    if (deleteItem) {
      const response = await deleteServiceGroup(user.barberShop, deleteItem.id);
      if (response.isSuccess) {
        setMessage({ text: response.value, type: "success" });
        setShowMessage(true);
        setDeleteItem(null);
        setShowDeleteModal(false);
        fetchServiceGroups();
      } else {
        setMessage({ text: response.data.errors.join("\n"), type: "danger" });
        setShowMessage(true);
        setShowDeleteModal(false);
        setDeleteItem(null);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewServiceGroup((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const handleEditChangeName = (e) => {
    setEditServiceGroupName({
      ...editServiceGroupName,
      name: e.target.value,
    });
  };
  const handleEditChangeOrder = (e) => {
    setEditServiceGroupName({
      ...editServiceGroupName,
      orderNumber: e.target.value,
    });
  };

  const onSave = async () => {
    try {
      const response = await createNewServiceGroup(
        newServiceGroup,
        user.barberShop,
      );
      if (response.data.isSuccess) {
        setMessage({ text: response.data.value, type: "success" });
        setShowMessage(true);
        await fetchServiceGroups();
        setShowNewModal(false);
      } else {
        setMessage({
          text: response.data.errors.join("\n"),
          type: "danger",
        });
        setShowMessage(true);
        setShowNewModal(false);
      }
    } catch (err) {
      console.error("Error fetching appointments:", err);
    }
  };
  const onEdit = async () => {
    if (editServiceGroupName) {
      const response = await updateServiceGroup(
        editServiceGroupName,
        user.barberShop,
      );
      if (response.data.isSuccess) {
        setMessage({ text: response.data.value, type: "success" });
        setShowMessage(true);
        setEditServiceGroupName(null);
        fetchServiceGroups();
        setShowEditModal(false);
      } else {
        setMessage({ text: "Update is failed", type: "danger" });
        setShowMessage(true);
        setEditServiceGroupName(null);
        setShowEditModal(false);
      }
    }
  };
  const handleDeleteClick = (service) => {
    setDeleteItem(service);
    setShowDeleteModal(true);
  };
  const onCloseDeleteModal = () => setShowDeleteModal(false);

  return {
    displayServiceGroups,
    showEditModal,
    showNewModal,
    newServiceGroup,
    onAddClick,
    handleChange,
    onSave,
    showMessage,
    setShowMessage,
    message,
    handleDeleteClick,
    handleConfirmDelete,
    showDeleteModal,
    onCloseDeleteModal,
    editServiceGroupName,
    setEditServiceGroupName,
    handleEditChangeName,
    handleEditChangeOrder,
    onEdit,
    onEditClick,
    onClosModal,
    columns,
  };
};
export default useServiceGroup;
